import gql from 'graphql-tag';

export default gql`
mutation($url: Boolean!) {
  setLastVisitedUrl(url: $url) @client
}
`;
